import {
  FETCH_ADMIN_FAILURE,
  FETCH_ADMIN_REQUEST,
  FETCH_ADMIN_SUCCESS,
} from "../actions/adminActions";

const initialState = {
  loading: false,
  admin: {},
  error: "",
  isLoaded: false,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_REQUEST:
      return { ...state, loading: true };
    case FETCH_ADMIN_SUCCESS:
      return {
        loading: false,
        isLoaded: true,
        admin: action.payload,
        error: "",
      };

    case FETCH_ADMIN_FAILURE:
      return {
        loading: false,
        isLoaded: false,
        admin: {},
        error: action.payload,
      };

    default:
      return state;
  }
};

export default adminReducer;
